import Vue from 'vue'

// export const apiURL = 'http://localhost:8080'
// export const apiURL = 'http://165.227.43.245/api'
export const apiURL = 'https://changeriskassessment.changevu.com/api'

export const EventBus = new Vue()



// WEBPACK FOOTER //
// ./client/globalConstants.js